export default "__VITE_ASSET__ff8fa14c__"